export class PropertyPublishingData{
    public propertyId! : number;
    public businessId! : string;
    public auctionIsLive : boolean = false;
    public comingSoon: boolean = false;
    public deleted : boolean = false;
    public physicallyDeleted :boolean = false;
    public updated? : string;
    public userId? : string;
    public publicUpdate? : boolean; //sent to public subscribers too (listed property)
    public photosOnly? : boolean; //only photos changed (saved without the property save): reload photos, edit mode stays

    constructor(){}

    /**
     * an update that changes nothing outside the property master: photos saved on their own without a change of the public listing
     * of a listed property (uploads, albums, captions...). Property lists and pages skip it, the property master reloads its photos.
     */
    public static isPhotosOnly(ppd: PropertyPublishingData | undefined): boolean {
        return !!ppd?.photosOnly && !ppd.publicUpdate;
    }
}
